export default __webpack_public_path__ + "static/IFP-new-7934a5a73f21302227af737fd525a097.jpg";